module.exports = __webpack_public_path__ + "media/images/flags/sg-f10f7273a0aa121c5ec6a05585d0b85c.svg";